import {
  ListItemButtonProps,
  ListItemButton as MUIListItemButton,
  styled,
} from "@mui/material";
import clsx from "clsx";

import styles from "./styles.module.css";

const ListItemButton = styled(MUIListItemButton)(({ theme, selected }) => ({
  padding: "11px 8px",
  borderRadius: "8px",
  backgroundColor: theme.palette.secondary.main,
  "&&.Mui-selected": {
    backgroundColor: selected ? "#D5DFFE" : theme.palette.secondary.main,
  },
  ":not(:last-child)": {
    marginBottom: "8px",
  },
  ":hover": {
    backgroundColor: "#D5DFFE",
  },
  ":has(button)": {
    paddingBlock: "3px",
  },
  "@media (hover: hover) and (pointer: fine)": {
    button: {
      opacity: 0,
      transition: "opacity 0.15s cubic-bezier(0.4, 0, 0.2, 1)",
    },
    ":hover": {
      button: {
        opacity: 1,
      },
    },
  },
}));

interface IProps extends ListItemButtonProps {
  hideTextOverflow?: boolean;
  children: React.ReactNode;
}

const StyledListItemButton = ({
  hideTextOverflow = false,
  children,
  ...restProps
}: IProps) => {
  return (
    <ListItemButton {...restProps}>
      <div
        className={clsx(styles.wrapper, {
          [styles["hide-text-overflow"]]: hideTextOverflow,
        })}
      >
        {children}
      </div>
    </ListItemButton>
  );
};

export default StyledListItemButton;
